module.exports = __webpack_public_path__ + "static/img/14.2209073.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/14.png
// module id = OLnA
// module chunks = 0